import { useEffect } from 'react';
import type { RefObject } from 'react';

/** 滚动加载阈值（px） */
const SCROLL_LOAD_THRESHOLD = 80;

/**
 * 文件库列表区滚动触底加载。
 * @param scrollContainerRef - `.dba-file-library__body` 容器
 * @param loadMore - 加载下一页
 * @param options - 加载态与列表长度（用于 effect 依赖）
 */
export const useFileLibraryScrollLoad = (
  scrollContainerRef: RefObject<HTMLElement>,
  loadMore: () => Promise<void>,
  options: {
    loading: boolean;
    loadingMore: boolean;
    noMore: boolean;
    filesLength: number;
  },
): void => {
  const { loading, loadingMore, noMore, filesLength } = options;

  useEffect(() => {
    const el = scrollContainerRef.current;
    if (!el) {
      return undefined;
    }

    const onScroll = (): void => {
      if (loading || loadingMore || noMore) {
        return;
      }
      const remain = el.scrollHeight - el.scrollTop - el.clientHeight;
      if (remain < SCROLL_LOAD_THRESHOLD) {
        void loadMore();
      }
    };

    el.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => el.removeEventListener('scroll', onScroll);
  }, [loading, loadingMore, noMore, loadMore, filesLength, scrollContainerRef]);
};
